import { render } from "./service.vue?vue&type=template&id=552cabae"
const script = {}

import exportComponent from "D:\\webqpyx\\qpyx-korea-webs-hongkong-cosmo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__